import React from 'react'
import Dropdown from '@ublique/components/Dropdown'

const CustomDropdown = ({
  onChange,
  className,
  fieldValue,
  items,
  disabled
}) => {
  return (
    <Dropdown
      titleText='Options'
      className={`${className}-dropdown`}
      selectedItem={fieldValue}
      disabled={disabled}
      items={items}
      itemToString={(item) => item.label}
      onChange={({ selectedItem }) =>
        onChange({
          params: { ...selectedItem, value: `'${selectedItem.value}'` }
        })
      }
    />
  )
}

export default CustomDropdown
